// Tooltip Layer
NP.Tooltip = (function( $ ) {
	var timer;

	function Tooltip( optAll ) {
		if ( !optAll ) optAll = {};

		this.els = $( optAll.elClass );
		//this._flyout = $( optAll.id );
		this._flyout = $('<section>', {
			'class' : 'ly_tooltip'
		}).appendTo('body');

		//if ( !this.els[0] || !this._flyout[0] ) return;

		this.isOn = !1;
		this.options = $.extend( {
			delay : 200,
			duration : 100,
			gap : 1,
			halfImg : 5
		}, optAll || {} );

		this.onBeforeShow = $.Callbacks();
		this.onHide = $.Callbacks();

		Tooltip.evtBind.call( this );
	}

	Tooltip.evtBind = function() {
		NP.contents.on( 'mouseover', this.options.elClass, this, function( e ) {
			if ( !$( this ).data( 'tooltip' ) ) return;

			e.data.show( $( this ) );
		}).on( 'mouseout', this.options.elClass, this, function( e ) {
			e.data.hide();
		});
	};

	Tooltip.prototype.show = function( el ) {
		var me = this;

		timer = setTimeout(function() {
			if ( !me.isOn ) return;
			clearTimeout( timer );

			me._flyout.css( 'width', '' ).html( '<span>' + el.data( 'tooltip' ) + '</span>' );

			var win = $( window ),
				fHeight = me._flyout.outerHeight(),
				fWidth = me._flyout.outerWidth(),
				offset = el.offset(),
				t = win.scrollTop() <= offset.top - me.options.gap - fHeight;

			me.onBeforeShow.fire( me._flyout );

			me._flyout.css({
				position : 'absolute',
				top : t ? offset.top - fHeight - me.options.gap : offset.top + el.outerHeight() + me.options.gap,
				left : offset.left - ( fWidth / 3 ) + ( el.outerWidth() / 2 ),
				width : fWidth,
				backgroundPosition : ( fWidth / 3 ) - me.options.halfImg + 'px ' + ( t ? 'bottom' : 'top' )
			}).appendTo('body').fadeIn( me.options.duration );

			/*var oH = me._flyout.outerHeight(),
				oW = me._flyout.outerWidth(),
				w = $( window ),
				sL = w.scrollLeft(),
				o = el.offset(),
				t = w.scrollTop() < o.top - oH - me.options.gap,
				m = oW / 3,
				n = ( oW - el.width() ) / 3,
				l = o.left - m - sL >= 0;

			me.onBeforeShow.fire( me._flyout );

			me._flyout.css({
				position : 'absolute',
				top : parseInt( o.top + ( t ? -oH - me.options.gap : el.height() + me.options.gap ) ),
				left : parseInt( l ? o.left - n  : sL ),
				backgroundPosition : parseInt( ( l ? m : m + o.left - n - sL >= 0 ? m + o.left - n - sL : 0 ) ) + 'px ' + ( t ? 'bottom' : 'top' )
			}).appendTo('body').fadeIn( me.options.duration );*/

			me.isOn = !0;
		}, me.options.delay);

		me.isOn = !0;
	};

	Tooltip.prototype.hide = function() {
		clearTimeout( timer );
		this._flyout.hide();

		this.onHide.fire( this._flyout );
		this.isOn = !1;
	};

	return Tooltip;
}( jQuery ));

var tooltip = new NP.Tooltip({
	elClass : '.js_tooltip',
	id : '#flyoutTooltip'
});
tooltip.onBeforeShow.add( NP.zIndex['+'] );
tooltip.onHide.add( NP.zIndex['-'] );
